export default (countryCode: string | undefined): boolean => {
    const US_ISO2CODE = "US";
    return countryCode === US_ISO2CODE;
};